import * as yup from 'yup';

export const schema = yup.object().shape({
  ratio: yup.string().required('One of Ratio variants must be selected'),
  style: yup.string().required('One of Style variants must be selected'),
  // INJECT
});
